import React, { FC, useMemo } from 'react';
import get from 'lodash/get';
import classNames from 'classnames';

import Icon from 'vibo-ui/Icon';

import { notificationIconByType } from './contstants';

import { NotificationIconProps } from './interface';

import useStyles from './style';

const NotificationIcon: FC<NotificationIconProps> = ({ notificationType }) => {
  const classes = useStyles();

  const icon = useMemo(() => get(notificationIconByType, notificationType), [notificationType]);

  return icon ? (
    <Icon
      className={classNames('notificationIcon', classes.notificationIcon, notificationType)}
      icon={icon}
      disableAutoFontSize
    />
  ) : null;
};

export default NotificationIcon;
